export const DIV_CLASS = 'w-loader';
const IMG_SRC = '/assets/img/ajax-loader.gif';
const IMG_ALT = 'Loading';

export function createLoader() {
  let div = document.createElement('div');
  let img = document.createElement('img');

  div.classList.add(DIV_CLASS);
  img.setAttribute('src', IMG_SRC);
  img.setAttribute('alt', IMG_ALT);

  div.appendChild(img);

  return div;
};
